import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { lenisRef } from "@/lib/lenis";
import { LangProvider } from "@/i18n";
import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "@/components/site/Navbar";
import { CursorGlow, ScrollProgress } from "@/components/site/fx";
import { Hero } from "@/components/site/Hero";
import { MarqueeStrip } from "@/components/site/MarqueeStrip";
import { Services } from "@/components/site/Services";
import { CustomSoftware } from "@/components/site/CustomSoftware";
import { CloudCompare } from "@/components/site/CloudCompare";
import { CostCalculator } from "@/components/site/CostCalculator";
import { Configurator } from "@/components/site/Configurator";
import { Coverage } from "@/components/site/Coverage";
import { TechStack } from "@/components/site/TechStack";
import { LiveMonitor } from "@/components/site/LiveMonitor";
import { AttackMap } from "@/components/site/AttackMap";
import { Architecture } from "@/components/site/Architecture";
import { NetworkMap } from "@/components/site/NetworkMap";
import { StatusPage } from "@/components/site/StatusPage";
import { About } from "@/components/site/About";
import { Team } from "@/components/site/Team";
import { Portfolio } from "@/components/site/Portfolio";
import { CaseStudies } from "@/components/site/CaseStudies";
import { Process } from "@/components/site/Process";
import { BeforeAfter } from "@/components/site/BeforeAfter";
import { Testimonials } from "@/components/site/Testimonials";
import { Insights } from "@/components/site/Insights";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";

function Home() {
  const location = useLocation();
  useEffect(() => {
    if (!location.hash) return;
    const id = location.hash;
    let count = 0;
    let tmo;
    const attempt = () => {
      const el = document.querySelector(id);
      const lenis = lenisRef.current;
      if (el) {
        if (lenis) lenis.scrollTo(el, { offset: -60, duration: 0.7 });
        else el.scrollIntoView({ behavior: "smooth" });
      }
      count += 1;
      if (count < 7) tmo = setTimeout(attempt, 400); // re-derulează ~2.8s cât se așază layout-ul
    };
    const start = setTimeout(attempt, 250);
    return () => { clearTimeout(start); clearTimeout(tmo); };
  }, [location]);

  return (
    <main>
      <Hero />
      <MarqueeStrip />
      <CustomSoftware />
      <CloudCompare />
      <CostCalculator />
      <Services />
      <TechStack />
      <LiveMonitor />
      <AttackMap />
      <Architecture />
      <NetworkMap />
      <StatusPage />
      <About />
      <Team />
      <Portfolio />
      <CaseStudies />
      <Process />
      <BeforeAfter />
      <Testimonials />
      <Insights />
      <Configurator />
      <Contact />
      <Coverage />
    </main>
  );
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true, wheelMultiplier: 1 });
    lenisRef.current = lenis;
    if (typeof window !== "undefined") window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      lenisRef.current = null;
    };
  }, []);

  return (
    <LangProvider>
      <BrowserRouter>
        <div className="App grain relative min-h-screen bg-ink-900 text-white antialiased">
          <Toaster theme="dark" richColors position="top-center" />
          <ScrollProgress />
          <CursorGlow />
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
          </Routes>
          <Footer />
        </div>
      </BrowserRouter>
    </LangProvider>
  );
}

export default App;
